import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { translate } from "utils";
import { LeftOutlined } from "@ant-design/icons";

interface Props {
	to?: string;
	onClick?: () => void;
}

export function GoBackBtn(props: Props) {
	const { to = "", onClick } = props;
	const navigate = useNavigate();
	return (
		<Button
			onClick={() => {
				if (onClick) {
					onClick();
					return;
				}

				if (to) {
					navigate(to);
					return;
				}
				navigate(-1);
			}}
			icon={<LeftOutlined />}
			type="primary"
			className="flex items-center !bg-[#595959] hover:bg-gray-600 border-0"
			htmlType="button"
		>
			{translate(`Go back`)}
		</Button>
	);
}
